<template>
  <div class="home_page">
    <div class="page_body">
      <router-view v-slot="{ Component }">
        <keep-alive max="100">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
    <div class="page_bottom">
      <van-tabbar
          class="tabbar"
          @change="onChange"
          v-model="tabbar_active">
        <van-tabbar-item
            v-show="loginType==0"
            to="/home/order_list"
            name="order" icon="wap-home-o">首页</van-tabbar-item>
        <van-tabbar-item
            v-show="loginType==0 && shopConfig.is_seize == 1"
            to="/home/grabbing"
            name="grabbing" icon="guide-o">抢单</van-tabbar-item>
        <van-tabbar-item
            v-show="loginType==0"
            to="/home/escalation"
            name="escalation" icon="upgrade">上报</van-tabbar-item>
        <van-tabbar-item
            to="/home/person"
            name="person" icon="contact-o">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import home from './index'
export default home
</script>

<style lang="less" scoped>
@import "./home.less";
</style>